var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZzz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.808,
    height: 48.146,
    viewBox: "0 0 52.808 48.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f9f7f6;}.b{fill:none;stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-693.81 -2814.695)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.338,23.376a10.561,10.561,0,0,0,10.7,10.162,10.775,10.775,0,0,0,8.97-4.726,9.6,9.6,0,0,0,3.1-.006c4.042-.659,6.969-3.666,6.9-6.914a7.427,7.427,0,0,0,5.532-7.11,7.5,7.5,0,0,0-7.61-7.391c-.233,0-.465.012-.694.032V7.391A7.5,7.5,0,0,0,25.637,0a7.675,7.675,0,0,0-5.986,2.83,7.718,7.718,0,0,0-4.625-1.523A7.5,7.5,0,0,0,7.417,8.7V8.7A7.5,7.5,0,0,0,0,16.089,7.458,7.458,0,0,0,6.338,23.376Z",
    transform: "matrix(-0.995, -0.105, 0.105, -0.995, 743.112, 2852.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.635,0,7.522,1.22,0,7.67,5.932,8.9",
    transform: "translate(710.967 2829.803) rotate(-6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,.056,4.759,0,.036,6.263l4.795-.055",
    transform: "translate(721.474 2834.049) rotate(-6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,.741,3.516,0,.941,5.332l3.542-.746",
    transform: "translate(730.278 2837.065) rotate(-6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.338,23.376a10.561,10.561,0,0,0,10.7,10.162,10.775,10.775,0,0,0,8.97-4.726,9.6,9.6,0,0,0,3.1-.006c4.042-.659,6.969-3.666,6.9-6.914a7.427,7.427,0,0,0,5.532-7.11,7.5,7.5,0,0,0-7.61-7.391c-.233,0-.465.012-.694.032V7.391A7.5,7.5,0,0,0,25.637,0a7.675,7.675,0,0,0-5.986,2.83,7.718,7.718,0,0,0-4.625-1.523A7.5,7.5,0,0,0,7.417,8.7V8.7A7.5,7.5,0,0,0,0,16.089,7.458,7.458,0,0,0,6.338,23.376Z",
    transform: "matrix(-0.995, -0.105, 0.105, -0.995, 741.772, 2854.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.5,7A3.5,3.5,0,1,0,0,3.5",
    transform: "translate(699.738 2847.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.5,7A3.5,3.5,0,1,0,0,3.5",
    transform: "matrix(-0.995, -0.105, 0.105, -0.995, 706.353, 2854.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.495,5A2.583,2.583,0,1,0,.27,3.736",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 695.617, 2856.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.495,5A2.583,2.583,0,1,0,.27,3.736",
    transform: "matrix(-0.995, -0.105, 0.105, -0.995, 699.773, 2862.017)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZzz);
export default __webpack_public_path__ + "static/media/zzz.4d4fa3a0820385b51f1f8bf1791727f3.svg";
export { ForwardRef as ReactComponent };